var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "L4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500",
      backgroundColor: "#eeeeee"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0b{fill:#ffffff;}\n\t\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0b",
    cx: 230,
    cy: 250,
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: 0.1,
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    repeatCount: "indefinite",
    restart: "always",
    values: "0;1;0"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0b",
    cx: 250,
    cy: 250,
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: 0.2,
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    repeatCount: "indefinite",
    restart: "always",
    values: "0;1;0"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0b",
    cx: 270,
    cy: 250,
    r: 6
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "opacity",
    begin: 0.3,
    calcMode: "linear",
    dur: "1s",
    fill: "remove",
    repeatCount: "indefinite",
    restart: "always",
    values: "0;1;0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderBanner);
export default __webpack_public_path__ + "static/media/loader-banner.203225e043693306556cad24bf206d99.svg";
export { ForwardRef as ReactComponent };